import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MaintenanceInterceptor } from '@services/maintenance/maintenance.interceptor';
import { MenuComponent } from '@app/core/menu/menu.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from '@app/core/paginator/custom-paginator-intl.service';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule],
  declarations: [MenuComponent],
  exports: [MenuComponent]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
        { provide: HTTP_INTERCEPTORS, useClass: MaintenanceInterceptor, multi: true }
      ]
    };
  }
}
